export const ACTOR_TYPE_LESSOR = 'companySigner'
export const ACTOR_TYPE_LESSEE = 'buyer'
